module.exports = __webpack_public_path__ + "images/dingtalk/plane@2x-64e0e19e2603f85c777c88d9f69c6387.png";